import { ZenodoFile } from '../ZenodoFile';
import { fetchZenodo } from '../fetchZenodo';
import { zenodoDepositionSchema } from './depositionSchema';
export class Deposition {
    zenodo;
    value;
    constructor(zenodo, deposition) {
        this.zenodo = zenodo;
        this.value = zenodoDepositionSchema.parse(deposition);
    }
    async createFile(file) {
        const formData = new FormData();
        formData.append('file', file);
        const response = await fetchZenodo(this.zenodo, {
            route: `deposit/depositions/${this.value.id}/files`,
            method: 'POST',
            body: formData,
            expectedStatus: 201,
        });
        return new ZenodoFile(this.zenodo, await response.json());
    }
    async listFiles() {
        const response = await fetchZenodo(this.zenodo, {
            route: `deposit/depositions/${this.value.id}/files`,
        });
        const files = (await response.json());
        return files.map((file) => new ZenodoFile(this.zenodo, file));
    }
    async deleteFile(fileId) {
        await fetchZenodo(this.zenodo, {
            route: `deposit/depositions/${this.value.id}/files/${fileId}`,
            method: 'DELETE',
            expectedStatus: 204,
        });
    }
    async retrieveFile(fileId) {
        const response = await fetchZenodo(this.zenodo, {
            route: `deposit/depositions/${this.value.id}/files/${fileId}`,
        });
        return new ZenodoFile(this.zenodo, await response.json());
    }
    async update(metadata) {
        const response = await fetchZenodo(this.zenodo, {
            route: `deposit/depositions/${this.value.id}`,
            method: 'PUT',
            body: JSON.stringify({ metadata }),
        });
        return new Deposition(this.zenodo, await response.json());
    }
}
//# sourceMappingURL=Deposition.js.map